// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2.22632 2H22.2263V11H2.22632V2ZM8.22827 5.5H6.22437V7.50391H8.22827V5.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M2.22632 13H22.2263V22H2.22632V13ZM8.22827 16.5H6.22437V18.5039H8.22827V16.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-data-filled')
export default class DataFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'data-filled',
    }
  }
}
